/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

const RadioButton = ((props) => {
  const {
    options,
    error,
    label,
    required,
    disabled,
    defaultselected,
    onChange
  } = props;

  return (
    <>
      <h5>{label} {required && <span style={{color: '#dc0a0a', fontSize: '14px'}}>*</span>}</h5>
      <se-radio-group
        data-testid='radioButton'
        direction='row'
        value = {defaultselected}
        required={required}
        disabled={disabled}
        style={{width: '100%'}}
      >
        {options &&
          options.map((option) => {
            return (
              <se-radio
                key={option.id}
                data-testid='radioOption'
                value={option.name}
                label={option.name}
                selected={option.checked}
                disabled={disabled}
                onClick={(event) =>  onChange(event.target.value)}
                style={{width: '100%'}}
              ></se-radio>
            );
          })}
      </se-radio-group>
      {error && <span className='errorMsg'>{error}</span>}
    </>
  );
});
export default RadioButton;

RadioButton.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  name: PropTypes.string.isRequired,
  handleCheckBoxSelect: PropTypes.func,
  multiselect: PropTypes.bool,
  formData: PropTypes.object,
  error: PropTypes.string,
  label: PropTypes.string,
  handleEvent: PropTypes.func,
  value: PropTypes.string,
};
